import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateUserAuthSettingsParams {
  userIds: string[];
  authSetting: string;
}

export class UpdateUserAuthSettingsRequest extends Request<IUpdateUserAuthSettingsParams, IResult> {
  constructor(userIds: string[], authSetting: string) {
    super('updateUserAuthSettings', { userIds: userIds, authSetting: authSetting });
  }
}
